/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Go_TimelineInputs */

const en_cmd_go_timeline = /** @type {(inputs: Cmd_Go_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to timeline`)
};

const de_cmd_go_timeline = /** @type {(inputs: Cmd_Go_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Zeitleiste`)
};

/**
* | output |
* | --- |
* | "Go to timeline" |
*
* @param {Cmd_Go_TimelineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_go_timeline = /** @type {((inputs?: Cmd_Go_TimelineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Go_TimelineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_go_timeline(inputs)
	return en_cmd_go_timeline(inputs)
});